import React, { createContext, useContext, useEffect, useState } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import { retrieveProducts } from './MainPortal/API/API_Handler';

const UserContext = createContext();

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider'); // {{ edit_1 }} Added error handling
    }
    return context;
};

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null); 
    const [isSignedIn, setIsSignedIn] = useState(false);
    const [userRole, setUserRole] = useState(null); 
    const [userStatus, setUserStatus] = useState(null);
    const [userPermissions, setUserPermissions] = useState(null); 
    const [userListings, setUserListings] = useState(null); 
    const [userOrders, setUserOrders] = useState(null); 
    const [userReviews, setUserReviews] = useState(null); 
    const [userMessages, setUserMessages] = useState([]); 
    const [publicProducts, setPublicProducts] = useState([]);

    async function currentAuthenticatedUser() {
        try {
            const currentUser = await getCurrentUser(); 
            if (currentUser) {
                setIsSignedIn(true);
            }
        } catch (err) {
            setIsSignedIn(false);
            setUser(null); 
        }
    }

    async function fetchPublicProducts() {
        try {
            const products = await retrieveProducts("");
            setPublicProducts(products);
        } catch (err) {
            //
        }
    }
    useEffect(() => {
        currentAuthenticatedUser();
        fetchPublicProducts();
    }, []);


    return (
        <UserContext.Provider value={{ 
        user, setUser, 
        isSignedIn, setIsSignedIn, 
        userRole, setUserRole,
        userStatus, setUserStatus,
        userPermissions, setUserPermissions,
        userListings, setUserListings,
        userOrders, setUserOrders,
        userReviews, setUserReviews,
        userMessages, setUserMessages,
        publicProducts
        }}>
            {children}
        </UserContext.Provider>
    );
};